export const actions = [
  { label: "Add Requirement", action: "add_requirement" },
];
